import formInputsTypes from '../simulatorConstant';
import AxeManuel from 'assets/img/axe-manuel.png';
import AxeMotorise from 'assets/img/axe-motorise.png';
import ManoeuvreManuel from 'assets/img/manoeuvre-manuel.png';
import MoteurRideau from 'assets/img/moteur-rideau.png';
import RideauMetallique from 'assets/img/rideau-metallique.png';
import TablierRideau from 'assets/img/tablier-rideau.png';
const Options = {
	id: 'OptionsVR',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: "Autre main d'oeuvre",
	name: 'Options',
	className: 'col-12 mt-6',
	classGroup: 'simulator-check',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'Création rideau métallique complet',
			value: 'Création rideau métallique complet',
			label: 'Création rideau métallique complet',
			isInline: true,
			lst_price: 0,
			product_id: 9495,
			description: '- Création complète d’un rideau métallique.',
		},
		{
			id: 'Ouverture du coffre non difficile',
			label: 'Ouverture du coffre (non difficile)',
			value: 'Ouverture du coffre non difficile',
			isInline: true,
			lst_price: 0,
			product_id: 9495,
			description: '- Ouverture du coffre du rideau métallique.',
		},
		{
			id: 'Ouverture du coffre difficile',
			label: 'Ouverture du coffre (difficile)',
			value: 'Ouverture du coffre difficile',
			isInline: true,
			lst_price: 0,
			product_id: 9495,
			description: '- Ouverture du coffre du rideau métallique.',
		},
		{
			id: 'Tirage de ligne électrique',
			label: 'Tirage de ligne électrique',
			value: 'Tirage de ligne électrique',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Tirage de la ligne électrique pour alimentation du moteur.',
		},
		{
			id: 'Mise en place des agrafes',
			label: 'Mise en place des agrafes',
			value: 'Mise en place des agrafes',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Mise en place des attaches du tablier du rideau métallique.',
		},
		{
			id: 'Branchement électrique',
			label: 'Branchement électrique',
			value: 'Branchement électrique',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Branchement électrique du moteur du rideau métallique.',
		},
		{
			id: 'Réglage fin de course',
			label: 'Réglage fin de course',
			value: 'Réglage fin de course',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Réglage des fins de course du rideau métallique.',
		},
		{
			id: 'Mise en service',
			label: 'Mise en service',
			value: 'Mise en service',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Mise en service et test du rideau métallique.',
		},
		{
			id: 'Mise à la décharge',
			label: 'Mise à la décharge',
			value: 'Mise à la décharge',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Mise à la décharge des éléments déposés.',
		},
		{
			id: 'Fermeture du coffre',
			label: 'Fermeture du coffre',
			value: 'Fermeture du coffre',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Fermeture et remise en place du coffre du rideau métallique.',
		},
	],
};

const voletComplet = {
	id: 'VOLET_COMPLET',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Rideau métallique complet',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: Options,
	nextStepData: Options,
	options: [
		{
			id: 'depose_volet_complet',
			label: 'Dépose rideau métallique complet',
			value: 'depose_volet_complet',
			description: '- Dépose complète du rideau métallique existant avec sécurisation.',
			imageUrl: RideauMetallique,
			isInline: true,
		},
		{
			id: 'pose_volet_complet',
			label: 'Pose rideau métallique complet',
			value: 'pose_volet_complet',
			description: '- Pose complète d’un rideau métallique avec réglages et essais.',
			lst_price: 300,
			imageUrl: RideauMetallique,
			isInline: true,
		},
	],
};

const tablier = {
	id: 'TABLIER',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Tablier',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: voletComplet,
	nextStep: voletComplet,
	options: [
		{
			id: 'depose_tablier',
			label: 'Dépose tablier',
			value: 'depose_tablier',
			description: '- Dépose du tablier du rideau métallique avec précaution.',
			imageUrl: TablierRideau,
			isInline: true,
		},
		{
			id: 'pose_tablier',
			label: 'Pose tablier',
			value: 'pose_tablier',
			description: '- Pose du tablier du rideau métallique.',
			lst_price: 300,
			imageUrl: TablierRideau,
			isInline: true,
		},
	],
};

const axeMotorise = {
	id: 'AXE_MOTORISE',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Axe motorisé',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: tablier,
	nextStep: tablier,
	options: [
		{
			id: 'depose_axe_motorise',
			label: 'Dépose axe motorisé',
			value: 'depose_axe_motorise',
			description: '- Dépose de l’axe motorisé du rideau métallique.',
			imageUrl: AxeMotorise,
			isInline: true,
		},
		{
			id: 'pose_axe_motorise',
			label: 'Pose axe motorisé',
			value: 'pose_axe_motorise',
			description: '- Pose d’un axe motorisé pour rideau métallique.',
			lst_price: 300,
			imageUrl: AxeMotorise,
			isInline: true,
		},
	],
};

const axeManuel = {
	id: 'AXE_MANUEL',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Axe manuel',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: axeMotorise,
	nextStep: axeMotorise,
	options: [
		{
			id: 'depose_axe_manuel',
			label: 'Dépose axe manuel',
			value: 'depose_axe_manuel',
			description: '- Dépose de l’axe manuel du rideau métallique.',
			imageUrl: AxeManuel,
			isInline: true,
		},
		{
			id: 'pose_axe_manuel',
			label: 'Pose axe manuel',
			value: 'pose_axe_manuel',
			description: '- Pose d’un axe manuel pour rideau métallique.',
			lst_price: 300,
			imageUrl: AxeManuel,
			isInline: true,
		},
	],
};

const moteur = {
	id: 'MOTEUR',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Moteur',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: axeManuel,
	nextStep: axeManuel,
	options: [
		{
			id: 'depose_moteur',
			label: 'Dépose moteur',
			value: 'depose_moteur',
			description: '- Dépose du moteur du rideau métallique.',
			imageUrl: MoteurRideau,
			isInline: true,
		},
		{
			id: 'pose_moteur',
			label: 'Pose moteur',
			value: 'pose_moteur',
			description: '- Pose d’un moteur pour rideau métallique.',
			lst_price: 300,
			imageUrl: MoteurRideau,
			isInline: true,
		},
	],
};

const MainOuvreDataRideau = {
	id: 'MO',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Manivelle',
	name: 'Manivelle',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStepData: moteur,
	nextStep: moteur,
	options: [
		{
			id: 'depose_manivelle',
			value: 'depose_manivelle',
			label: 'Dépose manivelle',
			description: '- Dépose de la manivelle du rideau métallique.',
			imageUrl: ManoeuvreManuel,
			isInline: true,
		},
		{
			id: 'pose_manivelle',
			label: 'Pose manivelle',
			value: 'pose_manivelle',
			description: '- Pose d’une manivelle pour rideau métallique.',
			lst_price: 300,
			imageUrl: ManoeuvreManuel,
			isInline: true,
		},
	],
};

export default MainOuvreDataRideau;
